import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { getActivitySubComments } from '../../../../../../../../../redux/modules/activityLog';
import ActivityLogSubRow from '../ActivityLogSubRow';

const ActivityLogComments = ({ activityId, comments = { data: [] } }) => {
  const dispatch = useDispatch();

  return (
    <>
      {comments.data.map(comment => (
        <ActivityLogSubRow
          comment={comment}
          key={comment.id}
        />
      ))}
      { comments.nextPageUrl && (
        <>
          { (comments.currentPage < comments.lastPage) && (
            <Box
              justifyContent="flex-start"
              ml="150px"
              my={2}
              onClick={() => dispatch(getActivitySubComments(activityId, comments.currentPage + 1))}
            >
              <Text
                _hover={{ color: 'primaryScale.600' }}
                color="greyScale.800"
                cursor="pointer"
                fontSize="sm"
                textAlign="left"
              >
                Show more
              </Text>
            </Box>
          ) }
        </>
      )}
    </>
  );
};

ActivityLogComments.propTypes = {
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  comments: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    currentPage: PropTypes.number,
    lastPage: PropTypes.number,
    nextPageUrl: PropTypes.string
  })
};

export default ActivityLogComments;
